import { render, staticRenderFns } from "./TranslatedText.vue?vue&type=template&id=7478b5d9"
import script from "./TranslatedText.vue?vue&type=script&lang=js"
export * from "./TranslatedText.vue?vue&type=script&lang=js"
import style0 from "./TranslatedText.vue?vue&type=style&index=0&id=7478b5d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports